import { flow, map, fromPairs, castArray } from 'lodash/fp'

/**
 * Create an object from an array of keys. Sets each value to 0
 */
export const createKeyObject = flow(
  map(key => [key, 0]),
  castArray,
  fromPairs
)



// WEBPACK FOOTER //
// src/features/CallAnalytics/utils/createKeyObject.ts